var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import classnames from 'classnames';
import { Card } from '../Card';
export const Spinner = (_a) => {
    var { className, container, size = 'medium' } = _a, props = __rest(_a, ["className", "container", "size"]);
    const SpinnerClasses = classnames('Spinner', {
        [`${className}`]: className && !container,
        'Spinner--large': size === 'large',
        'Spinner--medium': size === 'medium',
        'Spinner--small': size === 'small',
        'Spinner--tiny': size === 'tiny',
    });
    const CardClasses = classnames('Card__spinner', {
        [`${className}`]: className && container,
    });
    const RadiusSize = {
        large: 46,
        medium: 45,
        small: 44,
        tiny: 43,
    };
    const CircleRadius = RadiusSize[size];
    const spinnerComponent = (React.createElement("div", Object.assign({ className: SpinnerClasses }, props),
        React.createElement("svg", { className: "Spinner__svg", viewBox: "0 0 100 100", xmlns: "http://www.w3.org/2000/svg" },
            React.createElement("circle", { className: "Spinner__circle", cx: "50", cy: "50", r: CircleRadius }))));
    return container ? (React.createElement(Card, { className: CardClasses }, spinnerComponent)) : (spinnerComponent);
};
//# sourceMappingURL=Spinner.js.map